<template>
    <div>
        <b-container fluid>
            <app-supervision-activity-header>
                Formato revisión de circuito cerrado de televisión
            </app-supervision-activity-header>
        </b-container>
        <b-row class="my-2">
            <b-col>
                <app-form-select
                    label="Sede"
                    :options="venues"
                    v-model="venueId"
                    value-field="id"
                    text-field="name"
                ></app-form-select>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" md="6" class="py-2">
                <label for="camera">Cámara No. (*)</label>
                <b-form-input
                    type="number"
                    size="sm"
                    id="title"
                    v-model="detail.camera"
                    @input="$v.detail.camera.$touch()"
                    :valid="!$v.detail.camera.$error"
                ></b-form-input>
            </b-col>
            <b-col cols="12" md="6" class="py-2">
                <app-autocomplete
                    :items="vigilants"
                    v-model="detail.vigilant"
                    label="Guarda de turno (*)"
                    @input="$v.detail.camera.$touch()"
                    :valid="!$v.detail.camera.$error"
                    ref="vigilant-select"
                ></app-autocomplete>
            </b-col>
            <b-col cols="12" md="6" class="py-2">
                <label>Hora inicio (*)</label>
                <b-form-input
                    type="time"
                    v-model="detail.startHour"
                    @change="$v.detail.startHour.$touch()"
                    :state="
                        $v.detail.startHour.$dirty
                            ? !$v.detail.startHour.$error
                            : null
                    "
                ></b-form-input>
                <!-- <app-time-picker
                    v-model="detail.startHour"
                    @input="$v.detail.startHour.$touch()"
                    :valid="!$v.detail.camera.$error"
                ></app-time-picker> -->
            </b-col>
            <b-col cols="12" md="6" class="py-2">
                <label>Hora final (*)</label>
                <b-form-input
                    type="time"
                    v-model="detail.endTime"
                    @change="$v.detail.endTime.$touch()"
                    :state="
                        $v.detail.endTime.$dirty
                            ? !$v.detail.endTime.$error
                            : null
                    "
                ></b-form-input>
                <!-- <app-time-picker
                    v-model="detail.endTime"
                    @input="$v.detail.endTime.$touch()"
                    :valid="!$v.detail.camera.$error"
                ></app-time-picker> -->
            </b-col>

            <b-col cols="12" class="py-2">
                <b-form-textarea
                    id="textarea"
                    v-model="detail.observation"
                    placeholder="ingrese alguna observación"
                    rows="3"
                    max-rows="6"
                ></b-form-textarea>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" md="3">
                <b-btn
                    variant="primary"
                    @click="addRecord"
                    size="sm"
                    class="btn-block-xs-only"
                    >Agregar Registro</b-btn
                >
                <b-btn
                    variant="primary"
                    v-if="records.length > 0"
                    @click="openWindowfinalizeReport"
                    size="sm"
                    class="btn-block-xs-only"
                    >Finalizar reporte</b-btn
                >
            </b-col>
        </b-row>
        <b-row v-if="records.length > 0">
            <b-col cols="12">
                <div class="table-responsive">
                    <table class="table table-hover table-bordered table-sm">
                        <thead class="thead-orange">
                            <tr>
                                <th>Camara No.</th>
                                <th>Hora inicio</th>
                                <th>Hora fin</th>
                                <th>Guarda de turno</th>
                                <th>Observación</th>
                                <th>Acción</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="(record, index) in records"
                                :key="record.id"
                            >
                                <td>{{ record.camera }}</td>
                                <td>{{ record.startHour }}</td>
                                <td>{{ record.endTime }}</td>
                                <td>{{ record.vigilantName }}</td>
                                <td>{{ record.observation }}</td>
                                <td>
                                    <b-btn
                                        @click="deleteRecord(index)"
                                        class="btn btn-danger btn-sm"
                                    >
                                        <i
                                            class="fa fa-trash"
                                            aria-hidden="true"
                                        ></i>
                                    </b-btn>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </b-col>
        </b-row>
        <!-------------------------------- incio popup  ---------------------->
        <app-pop-up
            id="camera-review-finalize"
            title="Finalización de reporte"
            size="large"
        >
            <template slot="body">
                <b-row class="justify-content-left">
                    <b-col>
                        <h4>Resumen</h4>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12">
                        <div class="table-responsive">
                            <table
                                class="table table-hover table-bordered table-sm"
                            >
                                <thead class="thead-orange">
                                    <tr>
                                        <th>Cámara No.</th>
                                        <th>Hora inicio</th>
                                        <th>Hora fin</th>
                                        <th>Guarda de turno</th>
                                        <th>Observación</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="record in records"
                                        :key="record.id"
                                    >
                                        <td>{{ record.camera }}</td>
                                        <td>{{ record.startHour }}</td>
                                        <td>{{ record.endTime }}</td>
                                        <td>{{ record.vigilantName }}</td>
                                        <td>{{ record.observation }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </b-col>
                    <b-col cols="12" class="py-2">
                        <b-form-textarea
                            id="textarea"
                            v-model="novelty"
                            placeholder="Ampliación de informe por novedad"
                            rows="3"
                            max-rows="6"
                        ></b-form-textarea>
                    </b-col>
                    <b-col cols="12" class="py-2">
                        <b-form-textarea
                            id="textarea"
                            v-model="needAndRecomendation"
                            placeholder="Necesidades y recomendaciones"
                            rows="3"
                            max-rows="6"
                        ></b-form-textarea>
                    </b-col>
                    <b-col cols="12" class="py-2">
                        <b-form-textarea
                            id="textarea"
                            v-model="faultyEquipment"
                            placeholder="Equipos electrónicos defectuosos"
                            rows="3"
                            max-rows="6"
                        ></b-form-textarea>
                    </b-col>
                </b-row>
            </template>
            <template slot="buttons">
                <div>
                    <b-btn
                        id="btnSaveReport"
                        variant="primary"
                        @click="finalizeReport"
                        :disabled="inProgress"
                    >
                        <i class="fa fa-save"></i> Guardar
                    </b-btn>
                </div>
            </template>
        </app-pop-up>
        <!-------------------------------- fin popup  ---------------------->
    </div>
</template>
<script>
import SupervisionActivityHeader from '../SupervisionActivityHeader'
import { mapGetters } from 'vuex'
import { required } from 'vuelidate/lib/validators'

export default {
    components: {
        appSupervisionActivityHeader: SupervisionActivityHeader,
    },
    data() {
        return {
            detail: {
                camera: '',
                startHour: '',
                endTime: '',
                vigilant: '',
                observation: '',
            },
            novelty: '',
            needAndRecomendation: '',
            faultyEquipment: '',
            venues: [],
            vigilants: [],
            records: [],
            venueId: '',
        }
    },
    validations: {
        detail: {
            camera: { required },
            startHour: { required },
            endTime: { required },
            vigilant: { required },
        },
    },
    computed: {
        ...mapGetters(['supervisionClient']),
    },
    methods: {
        async finalizeReport() {
            const { data } = await repo.post(
                'supervision/save-report-camera-review',
                {
                    clientId: this.supervisionClient.id,
                    venueId: this.venueId,
                    novelty: this.novelty,
                    needAndRecomendation: this.needAndRecomendation,
                    faultyEquipment: this.faultyEquipment,
                    details: this.records,
                }
            )
            if (data.status) {
                toastr.success(data.msg)
                this.cleanForm()
                this.records = []
                this.$bus.$emit('camera-review-finalize.close')
            } else {
                toastr.error(data.msg)
            }
        },
        async loadVenues() {
            try {
                if (this.supervisionClient.id) {
                    const { data } = await repo.get('venues', {
                        client: this.supervisionClient.id,
                    })
                    this.venues = data
                    if (this.venues.length === 1) {
                        this.venueId = this.venues[0].id
                    }
                } else {
                    this.$router.push({ name: 'supervisionIndexPage' })
                }
            } catch (err) {
                this.handleErrors(err)
            }
        },
        addRecord() {
            this.$v.$touch()
            if (this.$v.$invalid) {
                toastr.error('ingrese la informacion requerida: (*)')
            } else {
                this.records.push({
                    camera: this.detail.camera,
                    startHour: this.detail.startHour,
                    endTime: this.detail.endTime,
                    observation: this.detail.observation,
                    vigilantName: this.detail.vigilant.name,
                    vigilantId: this.detail.vigilant.id,
                })
                this.cleanForm()
            }
        },
        openWindowfinalizeReport() {
            this.$bus.$emit('camera-review-finalize.open')
        },
        deleteRecord(index) {
            this.records.splice(index, 1)
        },
        cleanForm() {
            this.detail.camera = ''
            this.detail.vigilant = ''
            this.detail.observation = ''
            this.detail.startHour = ''
            this.detail.endTime = ''
            this.$v.$reset()
        },
        async loadVigilants() {
            const { data } = await repo.get('users/guards')
            this.vigilants = data
        },
    },
    mounted() {
        this.loadVenues()
        this.loadVigilants()
    },
}
</script>
